import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "wouter";
import img1 from "../../public/lovable-uploads/794bcc8e-4338-4129-9bd7-38e76b939a38.png";
import img2 from "../../public/lovable-uploads/logo-dark.png";
const NAV_LINKS = [
  { to: "/creators", label: "For Creators" },
  { to: "/businesses", label: "For Businesses" },
  { to: "/newsroom", label: "Newsroom" },
  { to: "/knowledge-hub", label: "Knowledge Hub" },

  { to: "/contact", label: "Contact" },
];
export default function Header({linkColor}) {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // track scroll
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed w-full backdrop-blur-md z-50 transition-all duration-500 ease-apple ${
        scrolled
          ? "bg-white/85 shadow-md border-b border-gray-200"
          : "bg-transparent"
      }`}
    >
      <div className="editorial-container">
        <div className="flex items-center justify-between py-2 md:py-3">
          {/* ─── Logo - Enlarged ───────────────────────────────────── */}
          <Link to="/" className="flex items-center">
            <img
              src={scrolled ? img2 : (linkColor == 'white' ? img1 : img2)}
              alt="Music Nation logo"
              className={`w-auto transition-all duration-300 ${
                scrolled
                  ? "h-16"
                  : "h-16" /* Enlarged from h-12/h-16 to h-16/h-20 */
              }`}
            />
          </Link>

          {/* ─── Desktop nav - Simplified to 4 items ───────────────────────────── */}
          <nav className="hidden md:flex items-center space-x-6">
            {NAV_LINKS.map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                className={`transition-colors duration-300 font-medium text-sm hover-underline font-sans ${
                  scrolled ? "text-musicBlack" : "text-musicWhite"
                }`}

                style={{color: scrolled ? "black" : (linkColor || "black")}}
              >
                {label}
              </Link>
            ))}
          </nav>

          {/* ─── Mobile menu icon ──────────────────────── */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className={`md:hidden transition-colors duration-300 ${
              scrolled
                ? "text-musicBlack hover:text-musicRed"
                : "text-musicWhite hover:text-musicRed"
            }`}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* ─── Mobile nav ──────────────────────────────── */}
      <div
        className={`md:hidden ${
          scrolled ? "bg-white" : "bg-musicBlack"
        } border-t ${
          scrolled ? "border-gray-200" : "border-musicGrey/20"
        } overflow-hidden transition-all duration-500 ease-apple ${
          isOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="editorial-container py-4">
          <nav className="flex flex-col space-y-4">
            {NAV_LINKS.map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                onClick={() => setIsOpen(false)}
                className={`transition-colors duration-300 font-medium py-2 font-sans ${
                  scrolled
                    ? "text-musicBlack hover:text-musicRed"
                    : "text-musicWhite hover:text-musicRed"
                }`}
              >
                {label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
}
